export function getSharedToken() {
    return 'sk-1e49426A5A63Ee3C33256F17EF152C02'
}